import { CheckmarkIcon } from '..';

interface Props {
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label?: string;
  labelClassName?: string;
}

const CheckmarkIconButton = ({
  checked,
  disabled = false,
  onClick,
  label,
  labelClassName,
}: Props) => {
  const wrapperClasses = [
    'flex w-fit items-center',
    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
  ].join(' ');

  const buttonClasses = [
    'flex h-[1.6rem] w-[1.6rem] items-center justify-center rounded-[.5rem] transition-colors',
    'focus:border-none focus:outline focus:outline-2 focus:outline-brand-secondary',
    checked ? 'bg-brand-secondary' : 'border-[1px] border-brand-light-gray',
    disabled ? 'pointer-events-none' : '',
  ].join(' ');

  return (
    <div
      className={wrapperClasses}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
    >
      <button
        type="button"
        className={buttonClasses}
        disabled={disabled}
        // prevent keyboard activation when disabled
        onKeyDown={(e) => {
          if (disabled && (e.key === 'Enter' || e.key === ' '))
            e.preventDefault();
        }}
      >
        {checked && <CheckmarkIcon height={8} width={12} variant="white" />}
      </button>

      {label && (
        <div className={`ml-[1rem] select-none ${labelClassName || ''}`}>{label}</div>
      )}
    </div>
  );
};

export default CheckmarkIconButton;
